module.exports = __webpack_public_path__ + "static/img/certified_logo.68573b30.svg";